<template lang="pug">
    .facebook-group-wrapper(:class="'context-'+context", v-if="context == 'esreps'")
        include FacebookGroup.pug
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'FacebookGroup',
    computed: mapState([
        "context",
    ]),
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";

@import "FacebookGroup";
</style>



// WEBPACK FOOTER //
// src/components/facebook-group/FacebookGroup.vue